// ---------------------------------------------------------------------------
// Financeiro › Controle de GPRS — a CONTA, lado do front.
//
// ⚠️⚠️ ESTE ARQUIVO É ESPELHO de `server/financeiro/gprs/gprs-regras.js`. Ele
//    existe porque a grade recalcula as duas diferenças ENQUANTO a pessoa digita,
//    e o front (Create React App) não importa de `server/`.
//    **Mudou um, muda o outro** — e a trava disso é
//    `server/tests/espelhos-back-front.test.js` (PAR 4), que compara o
//    COMPORTAMENTO dos dois lados sobre as mesmas entradas.
//
// ⚠️ AUTOCONTIDO de propósito: o carregador do teste roda este arquivo num `vm`
//    do Jest e falha se ele passar a ter `import` ou `export default`. Nada de
//    dependência aqui.
//
// A RÉGUA É A FITA POS, nos dois resultados — "quanto o outro sistema tem A MAIS
// que a Fita POS". O porquê inteiro (a planilha do SharePoint invertia o sinal no
// meio do mês) está no cabeçalho do arquivo do servidor.
// ---------------------------------------------------------------------------

/** Arredonda para centavos — ponto flutuante mente na subtração (1234.56 − 1234.55). */
export function centavos(n) {
    return Math.round(n * 100) / 100;
}

/**
 * As duas diferenças do controle.
 * ⚠️ Falta um dos lados → `null`, NUNCA 0: "não preenchido" não pode se parecer
 *    com "conferido e bateu".
 */
export function diferencas(valores) {
    const v = valores || {};
    const num = (x) => (x === null || x === undefined || x === '' ? null : Number(x));
    const equipamento = num(v.equipamento);
    const fitaPos = num(v.fitaPos);
    const flex = num(v.flex);

    const dif = (a, b) =>
        a === null || b === null || !Number.isFinite(a) || !Number.isFinite(b) ? null : centavos(a - b);

    return {
        maquinaVsFita: dif(equipamento, fitaPos),
        flexVsFita: dif(flex, fitaPos),
    };
}

/**
 * Texto digitado → número, ou `null` quando VAZIO.
 * ⚠️ Vazio e zero são coisas diferentes (ver o servidor). Os três casos que
 *    convivem no campo: '1.234,56' · '1.234' (milhar) · '1234.56' (teclado).
 */
export function normalizarValor(valor) {
    if (valor === null || valor === undefined) return null;
    if (typeof valor === 'number') return Number.isFinite(valor) ? valor : null;
    let s = String(valor).replace(/[^\d.,-]/g, '').trim();
    if (!s) return null;
    if (s.includes(',')) {
        // Tem vírgula → ela é o decimal, e todo ponto é separador de milhar.
        s = s.replace(/\./g, '').replace(',', '.');
    } else if (/^-?\d{1,3}(\.\d{3})+$/.test(s)) {
        // ⚠️ SEM vírgula e com ponto seguido de EXATAMENTE 3 dígitos ('1.234',
        //    '1.234.567') → o ponto é MILHAR, não decimal. A régua é segura
        //    porque centavo tem 2 casas, nunca 3: um valor em reais jamais se
        //    escreve '1.234' querendo dizer um e duzentos e trinta e quatro
        //    milésimos. Sem este ramo, o gerente que digita '1.234' grava R$ 1,23
        //    — mil reais viram um, e nada acusa.
        s = s.replace(/\./g, '');
    }
    // Qualquer outro ponto ('1234.56', vindo do teclado numérico) é decimal.
    const n = Number(s);
    return Number.isFinite(n) ? n : null;
}
